import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { WAITING_CALLS_BADGE_MAX_DISPLAY } from '../../hooks/calls/callUiConstants';

const WaitingCallsBadge = memo(({ anchorEl, visibleCount }) => {
  if (!anchorEl || visibleCount <= 0) return null;

  return createPortal(
    <span
      style={{
        position: 'absolute',
        top: -2,
        right: -6,
        minWidth: 16,
        height: 16,
        padding: '0 4px',
        borderRadius: 9999,
        backgroundColor: '#ef4444',
        color: '#fff',
        fontSize: 10,
        fontWeight: 700,
        lineHeight: '16px',
        textAlign: 'center',
        pointerEvents: 'none',
        zIndex: 1
      }}
      aria-hidden
    >
      {visibleCount > WAITING_CALLS_BADGE_MAX_DISPLAY
        ? `${WAITING_CALLS_BADGE_MAX_DISPLAY}+`
        : visibleCount}
    </span>,
    anchorEl
  );
});

WaitingCallsBadge.displayName = 'WaitingCallsBadge';

export default WaitingCallsBadge;
